export function cloneMap<K, V>(map: Map<K, V>): Map<K, V> {
	const result: Map<K, V> = new Map()
	map.forEach((value: V, key: K) => result.set(key, value))
	return result
}

export function cloneSet<V>(set: Set<V>): Set<V> {
	const result: Set<V> = new Set()
	set.forEach((value: V) => result.add(value))
	return result
}